"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconPin = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconPin = function SvgIconPin(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 6.75h-7.5V6A.75.75 0 013 5.25h.375L3.7.697A.75.75 0 014.447 0h3.104a.75.75 0 01.748.697l.326 4.553H9a.75.75 0 01.75.75v.75zm-3.473 4.969A.281.281 0 016 12h-.004a.281.281 0 01-.281-.281c0-.042-.085-1.199-.254-3.469H6.54a524.782 524.782 0 00-.262 3.469z",
    fill: "currentColor"
  }));
};

exports.SvgIconPin = SvgIconPin;